import { TradePair } from '../../../context/chart/chartTypes';
import { formatUSD, formatPercentages } from '../../../helpers';
import useTokenStats from '../../../hooks/web3/useTokenStats';

type Props = {
    pool: TradePair | null;
};

const MarketPrice: React.FC<Props> = ({ pool }) => {
    const tokenStats = useTokenStats();

    const percentageDifference = pool?.chartSymbol
        ? tokenStats?.[pool.chartSymbol]?.priceChangePercent ?? 0
        : 0;

    return (
        <div className='market-price'>
            {pool && tokenStats?.[pool.chartSymbol]?.price ? (
                <>
                    {formatUSD(tokenStats?.[pool.chartSymbol]?.price ?? 0, {
                        currency: '',
                        minDecimals: 2,
                        maxDecimals: pool.decimalFormatting,
                    })}
                    <span
                        className={percentageDifference >= 0 ? 'increased' : 'decreased'}
                    >
                        {formatPercentages(percentageDifference, 2)}%
                    </span>
                </>
            ) : (
                '-'
            )}
        </div>
    );
};

export default MarketPrice;
